<img />
<div id="content">
    <slot></slot>
</div>